import React, { useEffect, useMemo, useState } from 'react';
import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const IMAGE_BASE_URL_SMALL = 'https://media.server.theshootingwarehouse.com/small/';

const ItemImagePreviewLink = ({ itemNumber, description, onClick, typographyProps = {} }) => {
  const theme = useTheme();
  const [hasImage, setHasImage] = useState(Boolean(itemNumber));

  useEffect(() => {
    setHasImage(Boolean(itemNumber));
  }, [itemNumber]);

  const imageSrc = useMemo(() => {
    if (!itemNumber) return '';
    return `${IMAGE_BASE_URL_SMALL}${itemNumber}.jpg`;
  }, [itemNumber]);

  const previewContent = (
    <Box sx={{ width: 180 }}>
      {hasImage && imageSrc ? (
        <Box
          component='img'
          src={imageSrc}
          alt={description || `Item ${itemNumber}`}
          sx={{
            display: 'block',
            width: '100%',
            height: 180,
            objectFit: 'contain',
            borderRadius: 1,
            backgroundColor: theme.palette.background.paper,
          }}
          onError={() => setHasImage(false)}
        />
      ) : (
        <Box
          sx={{
            height: 180,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.75,
            color: theme.palette.text.secondary,
          }}
        >
          <InfoOutlinedIcon fontSize='small' />
          <Typography variant='caption'>Image not available</Typography>
        </Box>
      )}
    </Box>
  );

  return (
    <Tooltip
      title={previewContent}
      placement='right-start'
      enterDelay={150}
      arrow
      slotProps={{
        tooltip: {
          sx: {
            p: 1,
            bgcolor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.primary.main}33`,
            boxShadow: `0 10px 24px ${theme.palette.primary.main}20`,
          },
        },
      }}
    >
      <Typography
        variant='body1'
        onClick={onClick}
        sx={{
          color: '#1976d2',
          textDecoration: 'underline',
          cursor: 'pointer',
          ...typographyProps.sx,
        }}
        {...typographyProps}
      >
        {description}
      </Typography>
    </Tooltip>
  );
};

export default ItemImagePreviewLink;
